export default "__VITE_ASSET__Bu4_bist__"